import { render, staticRenderFns } from "./inventoryReports.vue?vue&type=template&id=508142c5&"
import script from "./inventoryReports.vue?vue&type=script&lang=js&"
export * from "./inventoryReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports